import React from 'react';
import PropTypes from 'prop-types';
import DivLayoutV2FieldGrid from './DivLayoutV2FieldGrid';
import './DivLayoutV2.css';

const DivLayoutV2Card = ({ badge, headerRight, fields, children }) => (
  <div className="div-layout-v2-card timeline-card-simple">
    {(badge || headerRight) && (
      <div className="card-header-simple">
        {badge && <span className="badge-simple history">{badge}</span>}
        {headerRight && (
          <span className="div-layout-v2-card-header-right">{headerRight}</span>
        )}
      </div>
    )}
    <div className="card-body-simple">
      {fields?.length > 0 && <DivLayoutV2FieldGrid fields={fields} />}
      {children}
    </div>
  </div>
);

DivLayoutV2Card.propTypes = {
  badge: PropTypes.string,
  headerRight: PropTypes.string,
  fields: PropTypes.array,
  children: PropTypes.node,
};

export default DivLayoutV2Card;
